import React from 'react'
import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers'
import { useController, UseControllerProps, useFormContext } from 'react-hook-form'

// RegisteredDateTimePicker Component
function RegisteredDateTimePicker({
    name,
    validation,
    ...props
}: DateTimePickerProps<Date> & {
    name: string
    validation?: UseControllerProps['rules']
}) {
    const { control } = useFormContext()

    // Using react-hook-form's useController to manage DateTimePicker state
    const {
        field: { onChange, value },
        fieldState: { error },
    } = useController({
        name,
        control,
        rules: validation,
    })

    const handleDateChange = (date: Date | null) => {
        onChange(date?.toISOString())
    }

    return (
        <DateTimePicker
            {...props}
            value={value ? new Date(value) : null}
            onChange={handleDateChange}
            slotProps={{
                textField: {
                    error: !!error,
                    helperText: error ? error.message : '',
                    variant: 'outlined',
                    InputLabelProps: { shrink: true },
                },
            }}
        />
    )
}

export { RegisteredDateTimePicker }
